module.exports = __webpack_public_path__ + "static/media/lock_logo.30f4fce5.svg";